<div class="filter-form {{ classDiv }}">
  <div class="filter-item">
    <input
      type="file"
      class="checkbox-input d-none"
      id="docFile"
      name="toggleCheckbox"
      data-testid="input-file"
      [disabled]="doc.length >= disable"
      [accept]="accept"
      (change)="onFileSelectedDoc($event)" />
    <label
      for="docFile"
      class="f13 flex align-items-center fw-bold radius-4 bg-light-blue py-8 pl-20 pr-30 mr-16 my-0 min-w-130px pointer">
      <ps-icon
        [iconClass]="iconClass"
        [iconColor]="iconColor"
        [srcIcon]="icon">
      </ps-icon>
      <span class="ml-16">{{ text }}</span>
    </label>
  </div>
  <div *ngFor="let itemD of doc; let indexD = index" class="filter-item">
    <div
      class="flex align-items-center radius-100 background-white border-DB py-8 pl-30 pr-10 my-0 max-w-230px h-40px">
      <span class="f14 text-ellipsis">{{ itemD.name }}</span>
      <ps-icon
        iconClass="ml-10 pointer"
        iconSize="xxsmall"
        attr.data-testid="icon-delete-{{ indexD }}"
        [srcIcon]="icons.cancel"
        (click)="deleteDoc(indexD)">
      </ps-icon>
    </div>
  </div>
</div>
